// extracted by mini-css-extract-plugin
var _1 = "CreatePasswordFormRequirementsItem-moduleCreatePasswordFormRequirementsItem__t9bGr";
var _2 = "CreatePasswordFormRequirementsItem-moduledotIconContainer__F56Qf";
export { _1 as "CreatePasswordFormRequirementsItem", _2 as "dotIconContainer" }
